module.exports = __webpack_public_path__ + "img/vignettes-asso_0008_frederic-sausset.17449d99.jpg";